const moment = require('moment')
const isNil = require('lodash/isNil')

const getStafferByUser = (value, schema, ctx) => {
  const { user, server: { get } } = ctx
  return get({
    url: 'api/model/staffers',
    query: {
      query: {
        userRef: `ObjectId('${user._id}')`,
      },
    },
  })
  .then(({ data: staffers }) => {
    const staffer = staffers[0]
    return {
      ...value,
      stafferRef: staffer,
      orderStafferRef: staffer,
      orderStafferKey: staffer && staffer.key,
      companyRef: staffer && staffer.companyRef,
      companyKey: staffer && staffer.companyRef && staffer.companyRef.key,
    }
  })
}

function validate25 (value) {
  if ((value * 100) % 25 !== 0) return '應為 0.25 的倍數'
  return undefined
}
function validateInt (value) {
  if (!Number.isInteger(value)) return '應為整數'
  return undefined
}
function validatePositive (value) {
  if (value < 0) return '應為正數'
  return undefined
}
function makeValidateRange (min, max) {
  return function validateRange (value) {
    if (value < min || value > max) return `應為 ${min} ~ ${max}`
    return undefined
  }
}
const degreeValidators = {
  s: validate25,
  c: validate25,
  a: [validateInt, makeValidateRange(0, 180)],
  add: [validatePositive, validate25],
}
function discountFormatter (value) {
  if (isNil(value)) return ''

  const m = value.toString().match(/0\.(\d+)/)
  if (Array.isArray(m) && m[1]) return `${m[1]}`

  return `${value}`
}
function discountParser (value) {
  if (!value) return value
  if (+value > 1) return +`0.${value.match(/\d+/g).join('')}`
  return +value
}

function itemValidator (item) {
  const { productRef } = item

  if (!productRef) return undefined
  const { type } = productRef
  if (type !== 'B') return undefined

  const { lensSpec } = item
  const { s, c } = lensSpec

  if (isNil(s)) return 's 為必填'
  if (isNil(c)) return 'c 為必填'

  return undefined
}

module.exports = {
  schema: {
    name: '銷貨單',
    type: 'Object',
    creator: getStafferByUser,
    contents: {
      key: {
        name: '貨單號碼', type: 'String',
        disabled: true,
        counter: {
          key: (ctx) => {
            const prefix = ctx.values.companyKey
            return `${prefix}${moment().format('YYMMDD')}`
          },
          value: (key, value) => {
            if (!key) return null
            return `${key}${value.toString().padStart(4, 0)}`
          },
        },
      },
      orderType: {
        name: '貨單類別', type: 'String',
        options: ['銷售', '寄賣'],
        creator: '銷售',
        required: true,
      },
      stafferRef: {
        name: '客服人員',
        type: 'ObjectId',
        reference: 'staffers',
        refKeys: ['key', 'name'],
        disabled: true,
        input: 'text',
        formatter: (staffer) => (!isNil(staffer) ? [staffer.key, staffer.name].join('-') : ''),
      },
      stafferKey: {
        name: '客服人員',
        type: 'String',
        disabled: true,
      },
      orderStafferRef: {
        name: '接單人員',
        type: 'ObjectId',
        reference: 'staffers',
        refKeys: ['key', 'name'],
        required: true,
      },
      orderStafferKey: {
        type: 'String',
      },
      companyRef: {
        name: '出貨公司',
        type: 'ObjectId',
        reference: 'companies',
        refKeys: ['key', 'name'],
        listen: 'stafferRef', talk: 'companyRef',
        disabled: true,
        input: 'text',
        formatter: (comp) => (!isNil(comp) ? [comp.key, comp.name].join('-') : ''),
      },
      companyKey: {
        type: 'String',
        disabled: true,
      },
      custOrderNo: {
        name: '採購單號', type: 'String',
      },
      customerRef: {
        // 提供自動完成選單來選擇客戶
        name: '客戶代號',
        type: 'ObjectId',
        reference: 'customers',
        refKeys: ['key', 'name'],
        required: true,
        autoFocus: true,
      },
      customerKey: {
        name: '客戶代號',
        type: 'String',
        listen: 'customerRef', talk: 'key',
        disabled: true,
      },
      customerName: {
        name: '客戶名稱',
        type: 'String',
        listen: 'customerRef', talk: 'name',
        disabled: true,
      },
      customerAddress: {
        name: '客戶地址',
        type: 'String',
        listen: 'customerRef', talk: 'address',
        disabled: true,
      },
      customerZip: {
        name: '客戶郵遞區號',
        type: 'String',
        listen: 'customerRef', talk: 'zip',
        disabled: true,
      },
      customerPhone: {
        name: '客戶電話',
        type: 'String',
        listen: 'customerRef', talk: 'phone',
        disabled: true,
      },
      customerGroupRef: {
        name: '客戶群組',
        type: 'ObjectId',
        reference: 'customerGroups',
        refKeys: ['key'],
      },
      customerGroup: {
        name: '客戶群組',
        type: 'String',
        disabled: true,
      },
      brandRef: {
        // 依據填入客戶帶出可選的品牌
        name: '品牌名稱',
        type: 'ObjectId',
        reference: 'brands',
        refKeys: ['key', 'name'],
        listen: 'customerRef', talk: 'brandRefs',
        required: true,
      },
      brandKey: {
        name: '品牌',
        type: 'String',
        listen: 'brandRef', talk: 'key',
      },
      salesRegionRef: {
        name: '業務區域',
        type: 'ObjectId',
        reference: 'salesRegions',
        listen: 'customerRef', talk: 'areaName',
        disabled: true,
      },
      salesRegion: {
        name: '業務區域',
        type: 'String',
        disabled: true,
      },
      salesRepRef: {
        name: '業務代表',
        type: 'ObjectId',
        reference: 'staffers',
        listen: 'customerRef', talk: 'sales',
      },
      salesRepName: {
        name: '業務代表',
        type: 'String',
        listen: 'customerRef', talk: 'Name',
        disabled: true,
      },
      salesRepPhone: {
        name: '業務電話',
        type: 'String',
        listen: 'customerRef', talk: 'sales',
        disabled: true,
      },
      deliveryNote: {
        name: '客戶說明',
        type: 'String',
        listen: 'customerRef', talk: 'deliveryNote',
      },
      printPrice: {
        name: '列印售價',
        type: 'Boolean',
        listen: 'customerRef', talk: 'printPrice',
        disabled: true,
        input: 'text',
        formatter: (print) => (print ? '是' : '否'),
      },
      orderDate: {
        name: '開單日期',
        type: 'Date',
        creator: '$$TODAY', format: 'YYYY/MM/DD',
        disabled: true,
      },
      billDate: {
        // user can revise, type-in YYYYMMDD to revise
        name: '結帳日期',
        type: 'Date',
        creator: '$$TODAY', format: 'YYYY/MM/DD',
        required: true,
      },
      total: {
        name: '總金額', type: 'Number',
      },
      summary: {
        name: '數量合計', type: 'String',
      },
      deleteOrder: {
        name: '刪除訂單', type: 'Boolean',
        formatter: (v) => (v ? '刪除' : ''),
      },
      items: {
        type: 'Array',
        contents: [{
          type: 'Object',
          validator: itemValidator,
          contents: {
            _id: { type: 'ObjectId', autogeneratable: true },
            key: {
              name: '銷貨項目編號', type: 'String',
              // default: ${key}-${SEQ,00},
            },
            productRef: {
              name: '連結商品', type: 'ObjectId',
              reference: 'products',
              refKeys: ['key', 'name'],
              required: true,
              autofill: { key: 'itemProduct', fill: v => v, manual: true },
            },
            productType: {
              type: 'String',
            },
            productKey: {
              type: 'String',
            },
            productName: {
              type: 'String',
            },
            processType: {
              type: 'String',
              name: '加工/代工',
            },
            productSpec: {
              name: '商品規格', type: 'String',
            },
            lensSpec: {
              name: '鏡片規格',
              type: 'Object',
              contents: {
                eye: {
                  name: 'EYE', type: 'String',
                  options: ['L', 'R'],
                },
                s: {
                  // 3=3.00; 3.5 = 3.50; -.5 = -0.50
                  name: 'S', type: 'Number',
                  format: '-0.00',
                  step: 0.25,
                  creator: 0,
                  // defaultWhenFocused: 0,
                  validateBeforeTouched: true,
                  validator: degreeValidators.s,
                  autofill: { key: 'itemS', fill: v => v, manual: true },
                },
                c: {
                  //  .75 =  -0.75 ; -.75 = -0.75 只有負值
                  name: 'C', type: 'Number',
                  format: '-0.00',
                  step: 0.25,
                  creator: 0,
                  // defaultWhenFocused: 0,
                  validateBeforeTouched: true,
                  validator: degreeValidators.c,
                  autofill: { key: 'itemC', fill: v => v, manual: true },
                },
                a: {
                  //  如何輸入 a 0 ~ 180, 正整數
                  name: 'A', type: 'Number',
                  validator: degreeValidators.a,
                  autofill: { key: 'itemA', fill: v => v, manual: true },
                },
                add: {
                  // 如何輸入 ADD 2=2.00 只有正值
                  name: 'ADD', type: 'Number',
                  format: '-0.00',
                  step: 0.25,
                  validator: degreeValidators.add,
                  autofill: { key: 'itemAdd', fill: v => v, manual: true },
                },
              },
            },
            priceRangeRef: {
              type: 'ObjectId',
              reference: 'priceRanges',
              refKeys: ['key'],
              lazyFetch: true,
            },
            pricebookRef: {
              type: 'ObjectId',
              reference: 'pricebooks',
              refKeys: ['key'],
              lazyFetch: true,
            },
            unitPrice: {
              // Item + S + C = pricekey
              name: '單價', type: 'Number',
              disabled: true,
              required: true,
            },
            bookPrice: {
              name: '表價', type: 'Number',
            },
            salePrice: {
              name: '售價', type: 'Number',
            },
            qty: {
              name: '數量', type: 'Number',
              creator: 1,
              required: true, initailValidation: true,
            },
            subtotal: {
              name: '小計', type: 'Number',
              // TODO use computer
            },
            itemNote: {
              // Max 20 chinese characters
              name: '品名備註', type: 'String',
            },
            discount: {
              name: '折數', type: 'Number',
              formatter: discountFormatter,
              formatterWhenFocused: discountFormatter,
              parser: discountParser,
              validator: (v) => {
                if (v !== 0 && (v > 1 || v < 0.7)) return '折數應該大於 7 折'
                return undefined
              },
            },
          },
        }],
      },
    },
  },
  index: {
    primary: {
      key: {
        key: 1,
      },
      unique: true,
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'key', width: 130 },
        { key: 'custOrderNo', width: 100 },
        { key: 'stafferRef', width: 75, formatter: (staffer) => staffer && staffer.name },
        { key: 'orderDate', width: 75, format: 'MM/DD' },
        { key: 'billDate', width: 75, format: 'MM/DD' },
        { key: 'customerGroupRef', width: 75 },
        { key: 'customerRef', width: 120 },
        { key: 'brandRef', width: 100, refKeys: ['name'] },
        { key: 'companyRef', width: 80, formatter: (comp) => comp && comp.name },
        { key: 'orderType', width: 75 },
        { key: 'summary', width: 90 },
        { key: 'deleteOrder', width: 75 },
      ],
    },
    editor: {
      groups: [
        {
          name: '',
          rows: [
            [{ key: 'key' }],
            [{ key: 'custOrderNo' }],
            [{ key: 'stafferRef' }],
          ],
        },
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./src/models/salesOrders.js